//ContinueButton.jsx

import React from 'react';

const ContinueButton = ({ onClick, ...props }) => {
    return (
        <button className="btn btn-primary weiter-button" onClick={onClick} {...props}>
            Weiter
        </button>
    );
};

const BackButton = ({ onClick, ...props }) => {
    return (
        <button className="btn btn-primary zurueck-button" onClick={onClick} {...props}>
            Zurück
        </button>
    );
};

const SendButton = ({ onClick, ...props }) => {
    return (
        <button className="btn btn-primary send-button" onClick={onClick} {...props}>
            Senden
        </button>
    );
}

export {ContinueButton, BackButton, SendButton};
